import { Heading } from 'components/src/typography';
import { Maybe } from 'types/generated';
import { HeadingType } from '@/types';

type Props = {
  heading?: HeadingType;
  color?: Maybe<string>;
  textColor?: Maybe<string>;
  containerClasses?: string;
  classes?: string;
  headingVariant: 'xl' | 'large' | 'medium' | 'small' | 'xs';
};

const TextWithInlineColor = ({
  heading,
  color = 'black-100',
  textColor = 'black-100',
  containerClasses = '',
  classes = '',
  headingVariant,
}: Props) => {
  const italicsColor = `text-${color}`;

  return (
    heading && (
      <div className={containerClasses}>
        {heading.content.map((c) =>
          c.content.map((item, index) => {
            const hasAnotherColor = item.marks.some((i) => i.type.includes('italic'));
            return (
              <Heading
                key={index}
                variant={headingVariant}
                classes={`inline ${hasAnotherColor ? italicsColor : `text-${textColor}`} ${classes}`}
              >
                {item.value}
              </Heading>
            );
          })
        )}
      </div>
    )
  );
};
export default TextWithInlineColor;
